import { atom } from 'jotai';
import { AgreementResponse } from 'services/models/AgreementResponse';
export const latestAgreementsAtom = atom<AgreementResponse[]|undefined>(undefined);
export const activationSuccessAtom = atom(false);
export const activationMessageAtom = atom("");